export default __webpack_public_path__ + "static/watches-024cccfe062755ab99659a5ede5dab65.png";